// SC 登録フロー（2026-08 方針変更: FormRun 継続・事前 CSV 登録）関連の型定義。
// バックエンドの API 契約は backends/views/participation_url_info.py,
// url_participation.py, measurement_period.py, mypage.py を参照。

/** 受診者ステータス（backends/lib/examinee_status.py の 8 種） */
export const EXAMINEE_STATUSES = [
  "primary_interview",
  "shipping_waiting",
  "device_arrival_waiting",
  "measurement_period_setting",
  "measuring",
  "device_returning",
  "report_sending_waiting",
  "completed",
] as const;

export type ExamineeStatus = (typeof EXAMINEE_STATUSES)[number];

/** ステータスの進行度（進行順の比較に使う） */
export function getExamineeStatusIndex(status: ExamineeStatus): number {
  return EXAMINEE_STATUSES.indexOf(status);
}

/** GET /api/participation/project/{url_id}/ のレスポンス */
export interface ParticipationUrlInfo {
  type: "project";
  organization_name: string | null;
  project_name: string | null;
}

/** POST /api/participation/project_entry/ のレスポンス */
export interface ProjectEntryResult {
  id: string;
}

export interface CognitoAuthenticationResultData {
  AccessToken: string;
  ExpiresIn: number;
  TokenType: string;
  RefreshToken: string;
  IdToken: string;
}

/** PUT /api/participation/project_entry/{id}/ のレスポンス */
export interface ProjectRegisterResult {
  AuthenticationResult: CognitoAuthenticationResultData;
  id: string;
  sleep_checkup: string;
  status: ExamineeStatus;
}

/** POST /api/participation/project_join/ のレスポンス */
export interface JoinResult {
  sleep_checkup: string;
  status: ExamineeStatus;
}

/** POST /api/measurement_period/ のレスポンス */
export interface MeasurementPeriodResult {
  sleep_checkup: string;
  measurement_start_date: string;
  measurement_end_date: string;
  status: ExamineeStatus;
}

export interface MyPageTodoItem {
  required: boolean;
  completed: boolean;
}

export interface MyPageTodo {
  primary_interview: MyPageTodoItem;
  device_id_registration: MyPageTodoItem;
  measurement_period: MyPageTodoItem;
}

/** GET /api/mypage/measurements/ の results 要素 */
export interface MyPageMeasurement {
  id: string;
  status: ExamineeStatus;
  status_label: string;
  category: "participating" | "past";
  measurement_start_date: string | null;
  measurement_end_date: string | null;
  /** category === "past" のときのみ存在する */
  report_url?: string;
  /** category === "participating" のときのみ存在する */
  todo?: MyPageTodo;
}

export interface MyPageMeasurementsResponse {
  results: MyPageMeasurement[];
}
